import { Grid, Tooltip} from "@mui/material";

export function getCtitemStruct(){
    return {
        id:{
            name:'id',
            label:'ID',
            value:'',
            error:false,
            errorMessage:'',
            required:false
        },
        
        businessid:{
            name:'businessid',
            label:'Business Id',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'ID'
        },
        title:{
            name:'title',
            label:'title',
            value:'',
            error:false,
            errorMessage:'You must enter title',
            required:true,
            fieldtype:'string'
        },
        ctid:{
            name:'ctid',
            label:'CT ID',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'ID'
        },
        quantity:{
            name:'quantity',
            label:'Quantity',
            value:'',
            error:false,
            errorMessage:'You must enter Quantity',
            required:true,
            fieldtype:'double'
        },
        unitid:{
            name:'unitid',
            label:'Unit Id',
            value:'',
            error:false,
            errorMessage:'You must enter Unit Id',
            required:true,
            fieldtype:'bodynamiclist'
        },
        unitname:{
            name:'unitname',
            label:'Unit Name',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
      }
}

export function getColumns(payload){
  let actionList = [
        
        { field: 'title', headerName: 'title', width:150 },
        { field: 'quantity', headerName: 'Quantity', width:150 },
        { field: 'unitname', headerName: 'Unit Name', width:150 },
  ];
  if (payload!==undefined){
    payload.actionList && payload.actionList.map((actionObj)=>{
    actionList.push(
      {
        field: actionObj.title,
        headerName: actionObj.title,
        sortable: false,
        width:60,
        disableClickEventBubbling: false,
        renderCell: (params) => {
          return (
              <Grid item onClick={()=>{actionObj.callBackMethod(params.row.id)}}>
                <Tooltip title={actionObj.title} sx={{cursor: "pointer"}}>
                  {actionObj.icon}
                </Tooltip>
              </Grid>
          );
        }
      })
    })
  }
  return actionList;
}

export function setData(data, formValues, setFormValues){
   
    setFormValues({
      ['id']:{
        ...formValues['id'],
        value:data.id,
      },
       ['businessid']:{
          ...formValues['businessid'],
          value:data.businessid,
        },['title']:{
          ...formValues['title'],
          value:data.title,
        },['ctid']:{
          ...formValues['ctid'],
          value:data.ctid,
        },['quantity']:{
          ...formValues['quantity'],
          value:data.quantity,
        },['unitid']:{
          ...formValues['unitid'],
          value:data.unitid,
        },['unitname']:{
          ...formValues['unitname'],
          value:data.unitname,
        },
      })
}